import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/components/icon';
export function QuoteCard(t0) {
  const $ = _c(13);
  const {
    quote
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="double-quote" className="mb-4 size-10" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== quote.text) {
    t2 = <p className="font-medium text-sm leading-relaxed">{quote.text}</p>;
    $[1] = quote.text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== quote.person) {
    t3 = <p className="font-medium text-sm opacity-60">{quote.person}</p>;
    $[3] = quote.person;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== quote.company) {
    t4 = <p className="font-medium text-sm">{quote.company}</p>;
    $[5] = quote.company;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="mt-6 font-sans">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="flex h-[350px] flex-col rounded-md border-2 border-christ-black p-6 md:h-[380px]">{t1}<blockquote className="flex flex-1 flex-col justify-between">{t2}{t5}</blockquote></div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}